import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  WELLNESS_CHECK_IN_ENTRY_POINTS,
  WELLNESS_CHECK_IN_ENTRY_POINTS_TYPE,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/mixpanelConstants'
import { PAGE_ROUTES } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/routingConstants'
import { HowAreYouFeelingTodayOption } from '@lyrahealth-inc/shared-app-logic/src/features/wellnessCheckIn/constants'

import { useWellnessCheckIn } from './useWellnessCheckIn'
import { useAppDispatch } from '../../data/storeConfiguration/store'
import {
  clearWellnessCheckInEntryPoint,
  setWellnessCheckInEntryPoint,
} from '../../features/wellnessCheckIn/data/wellnessCheckInActions'

export const useNavigateToWellnessCheckIn = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { resetWellnessCheckInValues } = useWellnessCheckIn()

  const navigateToWellnessCheckInForm = useCallback(
    ({
      entryPoint,
      clearFormValues = true,
      selectedMood,
    }: {
      entryPoint?: WELLNESS_CHECK_IN_ENTRY_POINTS_TYPE
      clearFormValues?: boolean // set to false to keep existing form values but still clear any previous results
      selectedMood?: HowAreYouFeelingTodayOption
    }) => {
      dispatch(clearWellnessCheckInEntryPoint())
      if (entryPoint === WELLNESS_CHECK_IN_ENTRY_POINTS.RESULTS) {
        resetWellnessCheckInValues({ clearResults: false })
      } else {
        resetWellnessCheckInValues({ clearFormValues })
      }
      if (entryPoint) {
        dispatch(setWellnessCheckInEntryPoint(entryPoint))
      }

      if (selectedMood) {
        navigate(`${PAGE_ROUTES.WELLNESS_CHECK_IN.DEFAULT}/2?initialMoodOption=${selectedMood}`)
      } else {
        navigate(`${PAGE_ROUTES.WELLNESS_CHECK_IN.DEFAULT}/1`, { state: { mixpanelEntryPoint: entryPoint } })
      }
    },
    [dispatch, navigate, resetWellnessCheckInValues],
  )

  const navigateToWellnessCheckInResults = useCallback(
    (entryPoint: WELLNESS_CHECK_IN_ENTRY_POINTS) => {
      dispatch(setWellnessCheckInEntryPoint(entryPoint))
      navigate(PAGE_ROUTES.WELLNESS_CHECK_IN.RESULTS)
    },
    [dispatch, navigate],
  )

  return {
    navigateToWellnessCheckInForm,
    navigateToWellnessCheckInResults,
  }
}
